import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import { Link } from "react-router-dom";
import { base_url } from "../../Api/Api";
import { Loader } from "../../Global/Loader";
// chart
import ReactDOM from "react-dom";
import {
  Chart,
  ChartAxis,
  ChartGroup,
  ChartLine,
  ChartVoronoiContainer,
} from "@patternfly/react-charts";

import Header from "../../Global/Header";

const MyScore = (props) => {
  const [progress, setProgress] = useState(0);
  const [state, setState] = useState({
    data: null,
    duration: "",
    statusBottomSheet: false,
    loader: true,
    starsFull: [],
    starsEmpity: [],
  });
  const [status, setStatus] = useState({
    weekly: true,
    monthly: false,
    annual: false,
  });

  useEffect(() => {

    base_url
      .get(`my_scores`,)
      .then((response) => {
        let chartConfig = changeChart(response.data.chart.weekly, 1);
        let starsFull = [];
        let starsEmpity = [];
        for (let i = 1; i <= 5; i++) {
          response.data.userStar >= i
            ? starsFull.push(i) //response.data.userStar
            : starsEmpity.push(i);
        }
        setState({
          ...state,
          data: response.data,
          maxScore: chartConfig.maximum,
          minScore: chartConfig.minimum,
          avragScore: chartConfig.avrag,
          duration: "weekly",
          loader: false,
          starsFull: starsFull,
          starsEmpity: starsEmpity,
        });
        const timer = setTimeout(() => {
          setProgress(
            (response.data.totalScores * 100) / response.data.max_score
          );
        }, 400);
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);

  const avrageChart = (values, target) => {
    let tempArry = values.map((item) => {
      return item[target];
    });
    let maximum = tempArry.length
      ? tempArry.reduce(function (a, b) {
          return Math.max(a, b);
        })
      : 100;

    let minmum = tempArry.length
      ? tempArry.reduce(function (a, b) {
          return Math.min(a, b);
        })
      : 0;
    return { maximum, minmum };
  };

  const changeChart = (target, type, duration) => {
    let earn = avrageChart(target, "earn");
    let lose = avrageChart(target, "lose");
    let maximum = earn.maximum > lose.maximum ? earn.maximum : lose.maximum;
    let minimum = earn.minmum < lose.minmum ? earn.minmum : lose.minmum;
    let avrag = (maximum - minimum) / 2 + minimum;
    if (type == 1) {
      return { maximum, minimum, avrag };
    } else {
      setStatus({
        weekly: duration == "weekly",
        monthly: duration == "monthly",
        annual: duration == "annual",
      });
      setState({
        ...state,
        maxScore: maximum,
        minScore: minimum,
        avragScore: avrag,
        duration: duration,
      });
    }
  };

  // toggle bottom sheet
  const closeBottomSheet = () => {
    setState({
      ...state,
      statusBottomSheet: !state.statusBottomSheet,
    });
  };

  return (
    <div className="instructpg my-score">
      <Loader active={state.loader} />
      <Header innerPage={true} title={"امتیازات من"} />
      <div className="body-myscore">
        <div className="progress-score">
          <div className="total-progress">
            <CircularProgress variant="determinate" value={progress} />
            <div className="details">
              <strong>
                {state.data == null ? "" : state.data.totalScores}
              </strong>
              <span>جمع کل امتیازات</span>
            </div>
          </div>
          <div className="total-text">
            <div className="style-score earned">
              <strong>
                <img src="/icons/max.svg" />
                {state.data == null ? "" : state.data.plusScores}
              </strong>
              <span>امتیازات کسب شده</span>
            </div>
            <div className="style-score spend">
              <strong>
                <img src="/icons/min.svg" />
                {state.data == null ? "" : state.data.minusScores}
              </strong>
              <span>امتیازات خرج شده</span>
            </div>
          </div>
          <Link to="/myScore/detailes">جزییات بیشتر</Link>
        </div>

        <div className="user-level">
          <div className="details">
            <span>سطح کاربری : </span>
            <strong>{state.data == null ? "" : state.data.userLevel}</strong>
            <i className="icon-exclamation" onClick={closeBottomSheet}></i>
          </div>
          <div className="stars">
            {state.starsEmpity.map((item) => (
              <i className="icon-favourite1"></i>
            ))}
            {state.starsFull.map((item) => (
              <i className="icon-favourites-filled-star-symbol"></i>
            ))}
          </div>
        </div>

        <div className="chart-score">
          {state.data == null ? null : (
            <div
              className="inner-chart"
              style={{ height: "250px", width: "100%" }}
            >
              <div className="btn-duration">
                <button
                  type="button"
                  className={status.weekly ? "active" : ""}
                  onClick={() =>
                    changeChart(state.data.chart.weekly, 0, "weekly")
                  }
                >
                  هفتگی
                </button>
                <button
                  type="button"
                  className={status.monthly ? "active" : ""}
                  onClick={() =>
                    changeChart(state.data.chart.monthly, 0, "monthly")
                  }
                >
                  ماهانه
                </button>
                <button
                  type="button"
                  className={status.annual ? "active" : ""}
                  onClick={() =>
                    changeChart(state.data.chart.annual, 0, "annual")
                  }
                >
                  سالانه
                </button>
              </div>
              <Chart
                containerComponent={
                  <ChartVoronoiContainer
                    labels={({ datum }) => `${datum.name}: ${datum.y}`}
                    constrainToVisibleArea
                  />
                }
                legendOrientation="vertical"
                legendPosition="right"
                minDomain={{ y: 0 }}
                width={640}
              >
                <ChartAxis
                  tickValues={[
                    0,
                    state.minScore,
                    state.avragScore,
                    state.maxScore,
                  ]}
                />
                <ChartAxis
                  dependentAxis
                  showGrid
                  tickValues={[
                    0,
                    state.minScore,
                    state.avragScore,
                    state.maxScore,
                  ]}
                />
                <ChartGroup>
                  <ChartLine
                    data={state.data.chart[state.duration].map((info) => {
                      return { name: "کسب کرده", x: info.name, y: info.earn };
                    })}
                    style={{
                      data: {
                        stroke: "#152b9f",
                      },
                    }}
                  />
                  <ChartLine
                    data={state.data.chart[state.duration].map((info) => {
                      return { name: "خرج کرده", x: info.name, y: info.lose };
                    })}
                    style={{
                      data: {
                        stroke: "#ff4337",
                      },
                    }}
                  />
                </ChartGroup>
              </Chart>
            </div>
          )}
        </div>
      </div>

      <SwipeableBottomSheet
        open={state.statusBottomSheet}
        onChange={() => closeBottomSheet()}
        overflowHeight={0}
      >
        <div style={{ height: "auto" }} className="bottom-sheet">
          <h4>{state.data == null ? "" : state.data.info.title}</h4>
          {state.data == null
            ? ""
            : state.data.info.levels.map((item) => (
                <div className="item-userlevel">
                  <div className="head">
                    <strong>{item.title}</strong>
                    <span>{item.score_description}</span>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
        </div>
      </SwipeableBottomSheet>
    </div>
  );
};

export default MyScore;
